import { Form } from "antd";
import React from "react";
import Input from "./BaseInput";

interface SellerRemarksFieldProps {}

const SellerRemarksField: React.FC<SellerRemarksFieldProps> = function (props) {
    return (
        <Form.Item label={<span className="search-field-label">卖家备注</span>} name="sellerRemarks">
            <Input allowClear />
        </Form.Item>
    );
};

export default React.memo(SellerRemarksField);
